import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import {
  Link,
  LinkIcon,
  CompanyIsFlag
} from '../'
import Styles from './CompanyIsTff.css'


@CSSModules(Styles, {allowMultiple:true})
export default class CompanyIsTff extends Component {
  static propTypes = {
    company: PropTypes.object.isRequired,
  }
  constructor(props){
    super(props)
    this.state = {}
  }

  render() {
    const iconTo = require( '../../../static/images/icons/tff-icon.svg' )

    return <div styleName='family-modal'>
      <div styleName='icon-row'>
        {
          this.props.company.is_to ?
            <CompanyIsFlag icon={iconTo} title='Tobacco producer'/> :
            null
        }
        {
          this.props.company.is_tm ?
            <CompanyIsFlag icon={iconTo} title='Tobacco-promoting entertainment'/> :
            null
        }
      </div>
    </div>
  }
}

